import Sidebar from '../../components/sidebar/Sidebar'
import Header from '../../components/headerbar/Header'
import './store.scss'
import {config} from '../../config'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import { useState, useEffect, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import _ from 'lodash'
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Store = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [key, setKey] = useState('0')
  const [storeDetails, setStoreDetails] = useState([])
  const [storeList, setStoreList] = useState([])
  const [isDataLoaded, setIsDataLoaded] = useState(false)

  // Get store details
  const GetStoreDetails = useCallback(() => {
    const url = config.apiurl + '/contact/get_contact'
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setStoreDetails(res?.data?.data?.results)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.get(url).then(onSuccess, onFailure).then(_ => setIsDataLoaded(true))
  }, [])
  useEffect(() => {
    key === '0' && GetStoreDetails()
  }, [GetStoreDetails, key])

  // Get stores list
  const GetStoresList = useCallback(() => {
    const url = config.apiurl + '/store'
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setStoreList(res?.data?.data)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.get(url).then(onSuccess, onFailure)
  }, [])
  useEffect(() => {
    key === '1' && GetStoresList()
  }, [GetStoresList, key])

  // Delete store
  const removeStore = (id) => {
    const url = config.apiurl + `/store/${id}`
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        GetStoresList()
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.delete(url, configdata).then(onSuccess, onFailure)
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-md-12">
              <div className="card mb-4">
                {' '}
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Store</h6>
                    </div>
                  </div>
                </div>
                <section>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                  >
                    {/* Store details table */}
                    <Tab eventKey="0" title="Store Details">
                      <div className="card-body px-0 pt-0 pb-2">
                        {isDataLoaded && storeDetails?.length < 1 && (
                          <div className="text-end m-2" >
                            <Link
                              className="btn bg-gradient-dark mb-0"
                              to="/addstoredetails"
                            >
                              <i className="fas fa-plus" aria-hidden="true"></i>
                              &nbsp;&nbsp;Add Store Details
                            </Link>
                          </div>
                        )}
                        <div className="table-responsive p-5">
                          <table className="table align-items-center mb-0 ">
                            <thead>
                              <tr>
                                <th className="text-secondary opacity-7 ">
                                  <p>S.No</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Contact Details</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Home Branch Details</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Social Media Links</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>Action</p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {!_.isEmpty(storeDetails) ? (
                                storeDetails.map((item, index) => (
                                  <tr key={item._id}>
                                    {/* Sno */}
                                    <td>
                                      <p className="text-xs mb-2">
                                        {index + 1}
                                      </p>{' '}
                                    </td>
                                    {/* Contact details */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            Mobile No : &nbsp;
                                            {item?.mobileNo}
                                          </p>
                                          <p className="text-xs mb-2">
                                            Email:&nbsp;{item?.email}
                                          </p>
                                          <p className="text-xs mb-2">
                                            WhatsApp No:&nbsp;
                                            <span className="text-secondary">
                                              {item?.whatsappNo}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Home branch details */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            Address : &nbsp;
                                            {item?.homeBranchAddress}
                                          </p>
                                          <p className="text-xs mb-2">
                                            City :&nbsp;{item?.homeBranchCity}
                                          </p>
                                          <p className="text-xs mb-2">
                                            Landline No:&nbsp;
                                            <span className="text-secondary">
                                              {item?.homeBranchLandlineNo}
                                            </span>
                                          </p>{' '}
                                          <p className="text-xs mb-2">
                                            Mobile No:&nbsp;
                                            <span className="text-secondary">
                                              {item?.homeBranchMobileNo}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Social media urls */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            Fb : &nbsp;
                                            {item?.fburl}
                                          </p>
                                          <p className="text-xs mb-2">
                                            Insta :&nbsp;{item?.instaurl}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Action */}
                                    <td>
                                      <Link
                                        to={`/editstoredetails/${item._id}`}
                                        className="btn btn-link text-dark px-3 mb-0"
                                      >
                                        <i
                                          className="fas fa-pencil-alt text-dark me-2"
                                          aria-hidden="true"
                                        ></i>
                                        Edit
                                      </Link>
                                      {/* <a
                                        className="btn btn-link text-danger text-gradient px-3 mb-0"
                                        // onClick={() => deleteSlider(item._id)}
                                      >
                                        <i
                                          className="far fa-trash-alt me-2"
                                          aria-hidden="true"
                                        ></i>
                                        Delete
                                      </a> */}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <>
                                  <tr>
                                    <th
                                      className="text-secondary opacity-7 text-center"
                                      colspan="5"
                                    >
                                      <p>Data not found</p>
                                    </th>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Tab>

                    {/* Store list table */}
                    <Tab eventKey="1" title="Stores List">
                      <div className="card-body px-0 pt-0 pb-2">
                        <div className="text-end m-2">
                          <Link
                            className="btn bg-gradient-dark mb-0"
                            to="/addstore"
                          >
                            <i className="fas fa-plus" aria-hidden="true"></i>
                            &nbsp;&nbsp;Add Store
                          </Link>
                        </div>
                        <div className="table-responsive p-5">
                          <table className="table align-items-center mb-0 ">
                            <thead>
                              <tr>
                                <th className="text-secondary opacity-7 ">
                                  <p>S.No</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Phone No</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Address</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>City</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>Action</p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {!_.isEmpty(storeList) ? (
                                storeList.map((item, index) => (
                                  <tr key={item._id}>
                                    {/* Sno */}
                                    <td>
                                      <p className="text-xs mb-2">
                                        {index + 1}
                                      </p>{' '}
                                    </td>
                                    {/* Phone */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            Mobile No:&nbsp;{item?.mobileNo}
                                          </p>
                                          <p className="text-xs mb-2">
                                            Landline No:&nbsp;{item?.landlineNo}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Address */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            {item?.address}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* City */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            {item?.city}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Action */}
                                    <td>
                                      <Link
                                        to={`/editstore/${item._id}`}
                                        className="btn btn-link text-dark px-3 mb-0"
                                      >
                                        <i
                                          className="fas fa-pencil-alt text-dark me-2"
                                          aria-hidden="true"
                                        ></i>
                                        Edit
                                      </Link>
                                      <div
                                        className="btn btn-link text-danger text-gradient px-3 mb-0"
                                        onClick={() => removeStore(item._id)}
                                      >
                                        <i
                                          className="far fa-trash-alt me-2"
                                          aria-hidden="true"
                                        ></i>
                                        Delete
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <>
                                  <tr>
                                    <th
                                      className="text-secondary opacity-7 text-center"
                                      colspan="5"
                                    >
                                      <p>Data not found</p>
                                    </th>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </section>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  )
}

export default Store
